var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountBackBtn = function SvgAccountBackBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "account-back-btn_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#account-back-btn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D242B",
    d: "m6.06 8 5.023 5.023a.62.62 0 0 1 .193.467.66.66 0 0 1-.204.468.64.64 0 0 1-.468.2.64.64 0 0 1-.467-.2L5.022 8.854q-.18-.18-.268-.405-.087-.225-.087-.448 0-.225.087-.45.088-.224.268-.404l5.115-5.114a.63.63 0 0 1 .473-.194q.273.005.473.204a.64.64 0 0 1 .198.468.64.64 0 0 1-.198.468z"
  }))));
};
export default SvgAccountBackBtn;